'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _is_js = _interopRequireDefault(require("is_js"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _Create = _interopRequireDefault(require("@material-ui/icons/Create"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _EditProfessionalDomainModal = _interopRequireDefault(require("Modals/EditProfessionalDomainModal"));
var _DeleteProfessionalDomainModal = _interopRequireDefault(require("Modals/DeleteProfessionalDomainModal"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
class ProfessionalDomainForm extends _react.Component {
  state = {
    loading: false,
    status_messages: {},
    editedProfessionalDomainId: undefined,
    deletingProfessionalDomainId: undefined,
    editProfessionalDomainModalOpen: false,
    deleteProfessionalDomainModalOpen: false
  };
  handleChange = _handleChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchProfessionalDomain();
  }
  fetchProfessionalDomain = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    component.setState({
      loading: true
    });
    qwest.post('/professional-domain/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        professional_domains: response.professional_domains
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const professional_domain = (0, _getFormData.default)({
      state: state,
      pattern: 'professional_domain['
    });
    qwest.post('/professional-domain/create', professional_domain).then(function (xhr, response) {
      component.clearForm();
      window.setTimeout(function () {
        component.fetchProfessionalDomain();
      }, 1500);
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('professional_domain[')).reduce(function (update, key) {
      if (_is_js.default.string(state[key])) {
        update[key] = '';
      } else if (_is_js.default.array(state[key])) {
        update[key] = [];
      } else if (_is_js.default.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  openEditProfessionalDomainModal = ({
    id
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      editedProfessionalDomainId: id,
      editProfessionalDomainModalOpen: true
    });
  };
  closeEditProfessionalDomainModal = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      editedProfessionalDomainId: undefined,
      editProfessionalDomainModalOpen: false,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    component.fetchProfessionalDomain();
  };
  openDeleteProfessionalDomainModal = ({
    id
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      deletingProfessionalDomainId: id,
      deleteProfessionalDomainModalOpen: true
    });
  };
  closeDeleteProfessionalDomainModal = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      deletingProfessionalDomainId: undefined,
      deleteProfessionalDomainModalOpen: false,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    component.fetchProfessionalDomain();
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let listProfessionalDomain = (state.professional_domains || []).sort(function (a, b) {
      let labelA = a.label.toLowerCase(),
        labelB = b.label.toLowerCase();
      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    }).map(currentProfessionalDomain => {
      return /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        spacing: 3,
        classes: props.classes,
        key: currentProfessionalDomain.label
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 4,
        classes: props.classes
      }, currentProfessionalDomain.label), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 8,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "small",
        onClick: () => component.openEditProfessionalDomainModal({
          id: currentProfessionalDomain._id
        }),
        className: "u-margin-left-5 u-margin-right-5"
      }, /*#__PURE__*/_react.default.createElement(_Create.default, null)), /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "secondary",
        variant: "contained",
        size: "small",
        onClick: () => component.openDeleteProfessionalDomainModal({
          id: currentProfessionalDomain._id
        }),
        className: "u-margin-left-5 u-margin-right-5"
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, null))));
    });
    let createProfessionalDomain = /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "u-margin-bottom-30 u-margin-left-15 u-margin-right-15 u-padding-top-5 u-padding-bottom-20 u-padding-left-15 u-padding-right-15",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement("h3", null, "Ajouter un domaine professionnel"), /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/professional-domain/create"
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['professional_domain[label]'],
      name: "professional_domain[label]",
      type: "text",
      label: "Nom du domaine",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 8,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "button",
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, "Valider", loader))), status));
    let output = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, createProfessionalDomain, /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "u-margin-bottom-30 u-margin-left-15 u-margin-right-15 u-padding-top-20 u-padding-bottom-20 u-padding-left-15 u-padding-right-15",
      elevation: 2
    }, listProfessionalDomain), /*#__PURE__*/_react.default.createElement(_EditProfessionalDomainModal.default, {
      id: state.editedProfessionalDomainId,
      open: state.editProfessionalDomainModalOpen,
      onClose: component.closeEditProfessionalDomainModal
    }), /*#__PURE__*/_react.default.createElement(_DeleteProfessionalDomainModal.default, {
      id: state.deletingProfessionalDomainId,
      open: state.deleteProfessionalDomainModalOpen,
      onClose: component.closeDeleteProfessionalDomainModal
    }));
    return output;
  }
}
exports.default = ProfessionalDomainForm;
